import { useState } from 'react';
import { AxiosError } from 'axios';
import { AuthCredentialsInterface, login } from 'providers/authProvider';
import { History } from 'history';

const defaultUserData = { username: '', password: '' };

interface useLoginInterface {
  (): {
    userData: AuthCredentialsInterface;
    onChangeField: (
      field: string,
    ) => (event: React.ChangeEvent<HTMLInputElement>) => void;
    doLogin: (loginData: AuthCredentialsInterface, history: History) => void;
    loginError: boolean;
    loginStarted: boolean;
    rateLimited: boolean;
    rateLimitMessage: string;
  };
}

export const useLogin: useLoginInterface = () => {
  const [userData, setUserData] =
    useState<AuthCredentialsInterface>(defaultUserData);
  const [loginError, setLoginError] = useState(false);
  const [loginStarted, setLoginStarted] = useState(false);
  const [rateLimited, setRateLimited] = useState(false);
  const [rateLimitMessage, setRateLimitMessage] = useState('');

  const onChangeField =
    (field: string) => (event: React.ChangeEvent<HTMLInputElement>) =>
      setUserData({ ...userData, [field]: event.target.value });

  const doLogin = async (
    loginData: AuthCredentialsInterface,
    history: History,
  ) => {
    try {
      setLoginError(false);
      setRateLimited(false);
      setRateLimitMessage('');
      setLoginStarted(true);
      const response = await login(loginData);
      history.push(response?.redirectTo || '/');
      setLoginStarted(false);
    } catch (error) {
      setLoginStarted(false);
      const axiosError = error as AxiosError<{ message?: string }>;
      if (axiosError?.response?.status === 429) {
        setRateLimited(true);
        setRateLimitMessage(
          axiosError.response.data?.message ||
            'Too many failed attempts, please try again later.',
        );
        setLoginError(false);
      } else {
        setLoginError(true);
        setRateLimited(false);
      }
    }
  };

  return {
    userData,
    onChangeField,
    doLogin,
    loginError,
    loginStarted,
    rateLimited,
    rateLimitMessage,
  };
};
